import { CreateSpaceQuestion } from "../spaces";

type NumberValue = number
type StringValue = string
type StringArrayValue = string[]
// type QuestionsValue = { question: string; type: string; choices?: string[] }[]
type NumberArrayValue = number[]
type BooleanValue = boolean

export enum MetaTypeEnum {
  number = "number",
  string = "string",
  stringArr = "string[]",
  questions = "questions",
  numberArr = "number[]",
  boolean = "boolean",
}

export enum MetaTableKeyEnum {
  Product = "product",
  Space = "space",
  SpaceAIConfig = "spaceAIConfig",
  Questions = "questions",
}

type BaseAppProductMeta = {
  id: number
  appProductId: number
  key: string
  tableKey: string
  isSync: boolean
  createdAt: Date
  updatedAt: Date
}

type BaseCreateAppProductMeta = Omit<
  BaseAppProductMeta,
  "id" | "appProductId" | "createdAt" | "updatedAt"
>

type AppProductMetaGeneral<T> =
  | ({
      metaType: MetaTypeEnum.number
      metaValue: NumberValue
    } & T)
  | ({
      metaType: MetaTypeEnum.string
      metaValue: StringValue
    } & T)
  | ({
      metaType: MetaTypeEnum.stringArr
      metaValue: StringArrayValue
    } & T)
  | ({
      metaType: MetaTypeEnum.questions
      metaValue: CreateSpaceQuestion
    } & T)
  | ({
      metaType: MetaTypeEnum.numberArr
      metaValue: NumberArrayValue
    } & T)
  | ({
      metaType: MetaTypeEnum.boolean
      metaValue: BooleanValue
    } & T)

export type AppProductMeta = AppProductMetaGeneral<BaseAppProductMeta>
export type CreateAppProductMeta =
  AppProductMetaGeneral<BaseCreateAppProductMeta>
